import { render } from "./Title.vue?vue&type=template&id=38698556&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=38698556&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38698556"]])

export default __exports__